import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SignupForm } from '../components/molecules/SignupForm';
import { useAuth } from '@hooks';
import { useErrorHandler } from '@hooks';

const SignupPage: React.FC = () => {
  const { signup } = useAuth();
  const { error, isLoading, handleAsync, clearError, showWarning } = useErrorHandler();
  const navigate = useNavigate();

  const handleSubmit = async (name: string, email: string, password: string, confirmPassword: string) => {
    clearError();
    if (!name || !email || !password || !confirmPassword) return;
    if (password !== confirmPassword) {
      showWarning('Las contraseñas no coinciden');
      return;
    }

    const result = await handleAsync(() => signup(name, email, password));
    if (result !== null) {
      navigate('/');
    }
  };

  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md p-8 bg-white shadow-md rounded-xl">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-800">Crear una cuenta</h1>
          <p className="mt-2 text-gray-600">Regístrate para comenzar a alquilar equipos de rehabilitación</p>
        </div>

        <SignupForm onSubmit={handleSubmit} isLoading={isLoading} error={error} />

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            ¿Ya tienes cuenta?{' '}
            <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500">
              Inicia sesión
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;